<script>
import SplashPage from './components/splash-page';

import MenuToggle from './components/menu-toggle';
import AppJumpLink from './components/app-jump-link';

import AppAccordion from './components/app-accordion';
import AppAccordionPanel from './components/app-accordion-panel';
import AppAccordionButton from './components/app-accordion-button';

export default {
	components: {
		SplashPage,
		MenuToggle,
		AppJumpLink,
		AppAccordion,
		AppAccordionPanel,
		AppAccordionButton,
	},
	mounted() {
		window.setTimeout( this.handleAnchor, 250 );
	},
	methods: {
		handleAnchor() {
			const { hash } = window.location;
			if ( hash ) {
				const targetEl = document.getElementById( hash.slice( 1 ) );
				if ( targetEl ) {
					const { top } = targetEl.getBoundingClientRect();
					const scrollTop = top + window.scrollY;
					window.scrollTo( {
						top: scrollTop,
						left: 0,
						behavior: 'smooth',
					} );
				}
			}
		},
	},
};
</script>

<style src="./styles/utilities.css"></style>
